import React from 'react';
import { Circle, OverlayView } from "@react-google-maps/api";

interface PropertyMarkerProps {
  marker: {
    id: string;
    position: { lat: number; lng: number };
    propertyType: string;
    property: any;
  };
  getSingleUnitMarkerOptions: (propertyType: string) => google.maps.CircleOptions;
  getMultiUnitMarkerStyle: (propertyType: string) => React.CSSProperties;
  onMarkerClick: (property: any) => void;
  toTitleCase: (text: string) => string;
}

const PropertyMarker: React.FC<PropertyMarkerProps> = ({
  marker,
  getSingleUnitMarkerOptions,
  getMultiUnitMarkerStyle,
  onMarkerClick,
  toTitleCase
}) => {
  const isMultiUnit = marker.property.multiUnitProperties && marker.property.multiUnitProperties.length > 1;
  
  if (isMultiUnit) {
    const unitCount = marker.property.multiUnitProperties.length;
    
    return (
      <OverlayView
        key={marker.id}
        position={marker.position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={(width, height) => ({
          x: -(width / 2),
          y: -(height / 2)
        })}
      >
        <div
          onClick={() => onMarkerClick(marker.property)}
          className="map-search-marker-container"
        >
          {/* Circle marker with unit count */}
          <div 
            className="map-search-marker-multi-unit"
            style={getMultiUnitMarkerStyle(marker.propertyType)}
          >
            {unitCount}
          </div>
        </div>
      </OverlayView>
    );
  }
  
  // For single-unit properties, use the original circle marker
  return (
    <Circle
      key={marker.id}
      center={marker.position}
      radius={4}  // map marker size
      options={getSingleUnitMarkerOptions(marker.propertyType)}
      onClick={() => onMarkerClick(marker.property)}
    />
  );
};

export default PropertyMarker; 